// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_response_removeUnifiedTeamPhoto(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "UnifiedProfileConversionCommitted",
    "UnifiedProfileConversionOutcomeUnknown",
    "UnifiedProfileNotUnifiedError",
    "UnifiedProfileUpdateFailed",
    "UpdateUnifiedAccountProfilePayload"
  ]);
}

let variablesConverter = {};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"removeUnifiedTeamPhoto_UpdateUnifiedAccountProfilePayload_profile":{"f":""},"removeUnifiedTeamPhoto":{"u":"response_removeUnifiedTeamPhoto"}}};

let wrapResponseConverterMap = {
  response_removeUnifiedTeamPhoto: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"removeUnifiedTeamPhoto_UpdateUnifiedAccountProfilePayload_profile":{"f":""},"removeUnifiedTeamPhoto":{"u":"response_removeUnifiedTeamPhoto"}}};

let responseConverterMap = {
  response_removeUnifiedTeamPhoto: unwrap_response_removeUnifiedTeamPhoto
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

let Utils = {};

let node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": (v1/*: any*/),
  "type": "UnifiedProfileNotUnifiedError",
  "abstractKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": (v1/*: any*/),
  "type": "UnifiedProfileConversionCommitted",
  "abstractKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": (v1/*: any*/),
  "type": "UnifiedProfileConversionOutcomeUnknown",
  "abstractKey": null
},
v5 = {
  "kind": "InlineFragment",
  "selections": (v1/*: any*/),
  "type": "UnifiedProfileUpdateFailed",
  "abstractKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publicUrl",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "MarketingProfileURLDetails",
  "kind": "LinkedField",
  "name": "urlDetails",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "baseUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UnifiedProfileImageFieldRemoveTeamPhotoMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "removeUnifiedTeamPhoto",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "UnifiedProfileSave_updatedAccountProfile"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "UpdateUnifiedAccountProfilePayload",
            "abstractKey": null
          },
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "UnifiedProfileImageFieldRemoveTeamPhotoMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "removeUnifiedTeamPhoto",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isAccountProfile"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/)
                    ],
                    "type": "IndividualAccountProfile",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "teamName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "brokerage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "website",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "about",
                        "storageKey": null
                      },
                      (v7/*: any*/),
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MarketingProfileSocialAccounts",
                        "kind": "LinkedField",
                        "name": "socialAccounts",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "facebook",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "instagram",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "linkedIn",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "twitter",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "yelp",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "youTube",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "tikTok",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProfilePhoto",
                        "kind": "LinkedField",
                        "name": "logo",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "width",
                                "value": 320
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "url",
                            "storageKey": "url(width:320)"
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UnifiedProfileImage",
                        "kind": "LinkedField",
                        "name": "unifiedTeamPhoto",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "width",
                                "value": 960
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "url",
                            "storageKey": "url(width:960)"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "TeamAccountProfile",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v6/*: any*/)
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "UpdateUnifiedAccountProfilePayload",
            "abstractKey": null
          },
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6c879967f7f4c8f0084cc9bd3f4406c3",
    "id": null,
    "metadata": {},
    "name": "UnifiedProfileImageFieldRemoveTeamPhotoMutation",
    "operationKind": "mutation",
    "text": "mutation UnifiedProfileImageFieldRemoveTeamPhotoMutation {\n  removeUnifiedTeamPhoto {\n    __typename\n    ... on UpdateUnifiedAccountProfilePayload {\n      __typename\n      profile {\n        __typename\n        ...UnifiedProfileSave_updatedAccountProfile\n        ... on Node {\n          __isNode: __typename\n          __typename\n          nodeId\n        }\n      }\n    }\n    ... on UnifiedProfileNotUnifiedError {\n      message\n    }\n    ... on UnifiedProfileConversionCommitted {\n      message\n    }\n    ... on UnifiedProfileConversionOutcomeUnknown {\n      message\n    }\n    ... on UnifiedProfileUpdateFailed {\n      message\n    }\n  }\n}\n\nfragment UnifiedProfileSave_updatedAccountProfile on AccountProfile {\n  __isAccountProfile: __typename\n  __typename\n  ... on IndividualAccountProfile {\n    nodeId\n    publicUrl\n    urlDetails {\n      baseUrl\n      slug\n    }\n  }\n  ... on TeamAccountProfile {\n    nodeId\n    teamName\n    brokerage\n    website\n    about\n    publicUrl\n    urlDetails {\n      baseUrl\n      slug\n    }\n    socialAccounts {\n      facebook\n      instagram\n      linkedIn\n      twitter\n      yelp\n      youTube\n      tikTok\n    }\n    logo {\n      url(width: 320)\n    }\n    unifiedTeamPhoto {\n      url(width: 960)\n    }\n  }\n}\n"
  }
};
})());

let wrap_response_removeUnifiedTeamPhoto = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_removeUnifiedTeamPhoto = unwrap_response_removeUnifiedTeamPhoto;
exports.wrap_response_removeUnifiedTeamPhoto = wrap_response_removeUnifiedTeamPhoto;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
